import React, { useEffect, useState } from 'react';

import { supabase } from '../supabaseClient';

const LiveVideo = () => {
  const [videoUrl, setVideoUrl] = useState<string | null>(null);

  useEffect(() => {
    const fetchVideoUrl = async () => {
      const { data, error } = await supabase
        .from('live_link')
        .select('text')
        .limit(1)
        .single();

      if (error) {
        console.error('Error fetching video URL:', error);
        return;
      } else {
        console.log(data);
      }

      setVideoUrl(data?.text || null);
    };

    fetchVideoUrl();
  }, []);

  if (!videoUrl) return null;

  const url = `https://www.youtube.com/embed/${
    videoUrl.includes('/live/')
      ? videoUrl.split('/live/')[1].split('?')[0]
      : videoUrl.split('v=')[1]
  }?autoplay=1&mute=1&controls=0&showinfo=0&rel=0&modestbranding=1`;
  console.log(url);
  return (
    <div style={{ width: '100%', maxWidth: '800px', margin: '0 auto' }}>
      <iframe
        width="100%"
        height="450"
        src={url}
        title="Live Stream"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default LiveVideo;
